module.exports = __webpack_public_path__ + "static/hubatka-38e44e4f3f42d127ae3df4f1d103b15c.jpg";